import { render, staticRenderFns } from "./ShowUser.vue?vue&type=template&id=527b13f2&"
import script from "./ShowUser.vue?vue&type=script&lang=js&"
export * from "./ShowUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports